import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../../../../components/toast/Toast';

import { useDeleteEntityXeroConnection } from '../../../../../queries/use-delete-entity-xero-connection';
import { Entity } from '../../../../../types/entity';

type XeroDisconnectConfirmProps = {
    isOpen?: boolean;
    entity: Entity;
    onClose: () => void;
    onCancel: () => void;
    onError: (message: string) => void;
};

function XeroDisconnectConfirm({ entity, onClose, onCancel, onError, isOpen = false }: XeroDisconnectConfirmProps): JSX.Element {
    const deleteEntityXeroConnectionQuery = useDeleteEntityXeroConnection(entity.id);

    function handleDisconnect(): void {
        deleteEntityXeroConnectionQuery.mutate(
            { entityId: entity.id },
            {
                onSuccess: () => {
                    onClose();
                    toastNotification('success', 'Xero disconnected!');
                },
                onError: (e) => {
                    onError(e.response?.data?.message ?? 'Something went wrong.');
                    toastNotification('error', 'Unable to disconnect from Xero!');
                },
            }
        );
    }

    return (
        <Dialog
            isOpen={isOpen}
            title="Do you want to disconnect from Xero?"
            description={`${entity.name} will no longer be able use Xero for a workpaper's trial balance source. You can reconnect to Xero at anytime.`}
            primaryAction="Disconnect"
            secondaryAction="Cancel"
            type="error"
            onClose={onClose}
            onSecondaryActionClick={onCancel}
            onPrimaryActionClick={handleDisconnect}
            isLoading={deleteEntityXeroConnectionQuery.isLoading}
        />
    );
}
export default XeroDisconnectConfirm;
